exports = module.exports = require("../../../../../../../web-ai-translation/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-area[data-v-457c2c78]{position:absolute;height:100%;margin:auto;width:100%}.sidebar-nav[data-v-457c2c78]{position:relative;flex:1;overflow-y:auto;overflow-x:hidden}.sidebar-nav[data-v-457c2c78]::-webkit-scrollbar{width:6px}.sidebar-nav[data-v-457c2c78]::-webkit-scrollbar-thumb{background-color:rgba(0,229,255,.2);border-radius:3px}.sidebar-nav[data-v-457c2c78]::-webkit-scrollbar-track{background-color:transparent}", ""]);

// exports
